import { useEffect, useState } from "react";
import { useForm, ValidationError } from '@formspree/react';
import STAR from "./images/star.png"
import APPSTORE from "./images/appstore.png"
import PLAYSTORE from "./images/playstore.png"
import LOGO from "./images/logo.png"
export default function Home6(){
    const [state, handleSubmit] = useForm("xyyqgbgr");
    const [mnb, setMNB] = useState(false)
    // const [asd, setASD] = useState(false)
    useEffect(()=>{if (state.succeeded) {
        setMNB(true)
    }})
    return (
        <div className="sans">
            <div className="bg-[url('./images/sky.jpeg')] bg-cover bg-center bg-no-repeat">
       <div className="text-center sm:flex flex-row justify-between px-2 sm:px-20 mb-2 sm:mt-8 pt-12 text-3xl">
        <div className="hidden sm:flex flex-row gap-4 ">
        <div className="hidden sm:block text-blue-300 backdrop-blur-xl">YOU POPPING</div>
        <div className="hidden sm:block text-red-300 backdrop-blur-xl">YOUR FLOOR</div>
        </div>
        <div className="text-yellow-400 backdrop-blur-xl">REPS BABY BOY</div>
       </div>
       <div className="px-6 sm:px-20">
        <div className="p-4 py-20 sm:p-20 bg-[conic-gradient(at_top,_var(--tw-gradient-stops))] from-blue-700 via-blue-800 to-gray-900 text-white sm:flex flex-row justify-evenly text-xl">
            <div className="sm:flex flex-col sm:flex-row text-center">
                <div className="w-52 m-auto">FIND ACTIVITIES BEFORE THEY HAPPEN</div>
                <div className="hidden sm:block  w-2 h-20 mx-4 sm:w-px bg-white"></div>
                <div className="m-auto my-4 sm:hidden block w-40  h-px  bg-white"></div>
                <div className="w-52 m-auto">JOIN ACTIVITIES WHEN THEY ARE HAPPENING</div>
            </div>
            <div className="w-20 hidden sm:block"></div>
            <div className="h-32 sm:hidden block"></div>
            <div className="sm:flex flex-col justify-center">
                <div className="text-center mb-4 w-96">
                <span className="text-yellow-200"> Earn 1 premium pass for joining.</span> Earn 1 premium pass for each person you refer. Join to get your code!
                </div>
                <div className="flex flex-col">
                {mnb&&<div className="m-auto">Thanks for sharing!</div>}
                {!mnb&&<div className="m-auto p-4 bg-blue-700">
                    <form onSubmit={handleSubmit}>
                        <div><input id="email" type="email" name="email" placeholder="Email" className="text-black w-72 p-2 bg-white"/></div>
                        <ValidationError prefix="Email" field="email" errors={state.errors}/>
                        <div className="mt-2 flex"><button type="submit" disabled={state.submitting} className="p-2 px-4 bg-black">JOIN WAIT LIST</button></div>
                    </form>
                </div>}
                {/* {!asd&&<div onClick={()=>setASD(true)} className="m-auto cursor-pointer flex flex-row gap-8">
                    <div><img src={PLAYSTORE} alt="play store"/></div>
                    <div><img src={APPSTORE} alt="app store"/></div>
                </div>} */}
                </div>
            </div>
        </div>
       </div>
       <div className="flex"><div className="text-5xl text-center px-2 my-8 font-bold text-green-600 backdrop-blur-xl m-auto">PAY ONLY IF YOU HAVE A GOOD EXPERIENCE</div></div>
       <div className="sm:flex flex-row mx-2 sm:mx-20 mt-8 text-2xl">
        <div className="relative w-full sm:w-1/4 h-80">
            <div className="absolute text-xl sm:left-0 pl-2 left-3/4 top-2/4 sm:top-0 w-24 text-yellow-500 backdrop-blur-xl">HIT THAT TARGET</div>
            <div className="absolute top-1/4 text-4xl left-4 sm:left-2/4 overflow w-56 text-blue-700 font-bold backdrop-blur-xl pl-3">GET DOWN</div>
            <div className="absolute top-3/4 sm:left-0 left-12 text-blue-600 text-3xl backdrop-blur-xl">TRUCK COMING</div>
        </div>
        <div className="relative w-full sm:w-1/4 sm:h-80 h-40">
            <div className="absolute top-1/4 sm:top-2/4 font-bold text-red-600 left-1/4 sm:left-2/4 w-32 text-center backdrop-blur-xl">IN THE MOMENT</div>
        </div>
        <div className="relative w-full sm:w-1/4 h-80">
            <div className="absolute top-1/4 text-blue-700 left-1/4 w-72 sm:text-center text-5xl font-bold backdrop-blur-xl">GET OUT</div>
            <div className="absolute top-3/4 text-blue-800 left-0 w-96 text-center tracking-wide backdrop-blur-xl">DISTURBANCES OFF</div>
        </div>
        <div className="relative w-full sm:w-1/4 h-80">
            <div className="absolute  top-8 left-8 sm:-left-12 text-blue-900  text-center tracking-wide backdrop-blur-xl">TO THE EXTREME</div>
            <div className="absolute top-2/4 left-2/4"><img src={STAR} alt="Star"/></div>
        </div>
       </div>
       </div>
       {/* <div>
        <div>Starts from 2 member groups</div>
        <div>Upto 30 member groups</div>
       </div> */}
       <div className="bg-transparent absolute top-2 font-bold left-4 sm:left-12 text-xs flex flex-row gap-4">
        <img src={LOGO} alt="stepshare logo" className="w-6"/>
       <div>STEPSHARE</div>
       <div className="hover:text-blue-500"><a href="/faq">FAQ</a></div>
       <div className="hover:text-blue-500"><a href="/faq">COUNT YOUR PREMIUM PASSES</a></div>
       </div>
       <div className="flex w-full bg-[url('./images/gym.jpeg')] bg-cover bg-center bg-no-repeat h-[400px]">
       <div className="flex text-7xl flex-row gap-12 m-auto font-extrabold text-white">
        <div>TRAIN</div>
        <div>OR</div>
        <div>GET TRAINED</div>
       </div>
       </div>

       <div className="text-center text-white py-20 text-8xl p-40 bg-[url('./images/cycling.jpeg')] bg-cover bg-center bg-no-repeat h-[600px] ">The App for Those who Want to Excel in Real World Activities</div>
        </div>
    );
}